<i18n src="@/locales/modules/NoteTranslate.json"></i18n>

<template>
	<div class="note-filter flex flex-wrap items-center lg:justify-around">
		<div :class="['filter-item mr-3 lg:w-full lg:text-center lg:mb-3 xl:w-auto xl:mb-0', {'is-active': activeId === 'all'}]">
			<a
				href="#"
				class="font-bold text-solid-primary underline"
				@click.prevent="$emit('click', 'all')"
				v-if="value && value.length > 0"
			>{{ $t("All") }}</a>
		</div>

		<div
			:class="['filter-item mr-3 cursor-pointer lg:mr-0', {'is-active': activeId === data.id}]"
			v-for="(data, index) in value"
			:key="index"
			@click.stop="$emit('click', data)"
		>
			<div class="rounded-full w-8 h-8" :style="{backgroundColor: data.value}"></div>
		</div>
	</div>
</template>

<script>
import _ from "lodash";

export default {
	name: "NoteFilter",
	props: {
		value: {
			type: Array,
			validator: prop => {
				if (!_.isEmpty(prop)) {
					return !_.some(prop, data => {
						return !(_.has(data, "id") && _.has(data, "value"));
					});
				}
				return true;
			}
		},
		activeId: {
			type: [String, Number]
		}
	}
};
</script>

<style lang="scss" scoped>
.note-filter {
	.filter-item {
		transition: var(--common-transition);

		&.is-active {
			div {
				border: 2px solid var(--color-black);
			}
		}
	}
}
</style>
